import { combineReducers } from 'redux';
import { replaceOrAddAnswer } from '../../CustomFieldValues/perTicketAnswers';

import {
  CONFIRM_CHANGED,
  PROMO_CODE_NAME_CHANGED,
  PROMO_CODE_NAME_VALID_CHANGED,
  PROMO_CODE_CHANGED,
  TICKET_RESERVATION_CHANGED,
  TICKET_TYPES_CHANGED,
  CANCEL_CHECKOUT,
  STRIPE_PROMISE_CHANGED,
  STRIPE_ERROR_CHANGED,
  CHECKOUT_TIME_PERCENTAGE_REMAINING_CHANGED,
  TIME_LIMIT_REACHED_CHANGED,
  IS_PLACING_ORDER_CHANGED,
  ADD_ONS_CHANGED,
  GTAG_CHANGED,
  CUSTOM_FIELD_VALUE_CHANGED,
  SEATS_IO_CHART_CHANGED,
  SEATS_IO_SELECTED_OBJECTS_CHANGED,
  CUSTOMERIO_ID_CHANGED,
  PARENT_URL_CHANGED,
  ORIGIN_ATTRIBUTION_CHANGED,
  META_CLICK_ID_CHANGED,
  ATTRIBUTION_VISITOR_CHANGED,
  IS_CREATING_TICKET_RESERVATION_CHANGED,
  CART_START_BUSY_MESSAGE_CHANGED,
  INSURANCE_OFFER_STATE_CHANGED,
  TICKET_INSURANCE_CHANGED,
  HAS_INSURANCE_QUOTE_CHANGED,
  DONATION_CUSTOM_CHARGE_TYPE_CHANGED,
  TICKET_GROUPS_CHANGED,
  REVEALED_HOLD_CHANGED,
  USER_CONTEXT_CHANGED,
  MEMBERSHIP_PRODUCTS_CHANGED,
  SELECTED_MEMBERSHIP_PRODUCT_CHANGED,
  WIDGET_CONFIG_REPLACED,
  CHECKOUT_CATEGORIES_REPLACED,
  RESALE_LISTINGS_FETCHED,
  RESALE_QUANTITY_CHANGED
} from '../constants/webOrderFormConstants';

const team = (state = {}, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const csrfToken = (state = "", action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const priceQuoteToken = (state = null, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const priceQuoteVisitorId = (state = null, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const checkoutToken = (state = null, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const revealedHold = (state = {}, action) => {
  switch (action.type) {
    case REVEALED_HOLD_CHANGED:
      return action.revealedHold;
    default:
      return state;
  }
};

const confirm = (state = {}, action) => {
  switch (action.type) {
    case CONFIRM_CHANGED:
      return action.confirm;
    default:
      return state;
  }
};

const ticketTypes = (state = [], action) => {
  switch (action.type) {
    case TICKET_TYPES_CHANGED:
      return action.ticketTypes;
    case CANCEL_CHECKOUT:
      return [...state].map((tt) =>
        Object.assign({}, tt, {quantity: 0})
      );
    default:
      return state;
  }
};

const promoCode = (state = {}, action) => {
  switch (action.type) {
    case PROMO_CODE_CHANGED:
      return action.promoCode;
    case CANCEL_CHECKOUT:
      return {};
    default:
      return state;
  }
};

const promoCodeName = (state = "", action) => {
  switch (action.type) {
    case PROMO_CODE_CHANGED:
      return "";
    case PROMO_CODE_NAME_CHANGED:
      return action.name;
    case CANCEL_CHECKOUT:
      return "";
    default:
      return state;
  }
};

const promoCodeNameValid = (state = true, action) => {
  switch (action.type) {
    case PROMO_CODE_CHANGED:
      return true;
    case PROMO_CODE_NAME_VALID_CHANGED:
      return action.valid;
    case PROMO_CODE_NAME_CHANGED:
      return true;
    case CANCEL_CHECKOUT:
      return true;
    default:
      return state;
  }
};

const promoCodeInvalidReason = (state = null, action) => {
  switch (action.type) {
    case PROMO_CODE_NAME_VALID_CHANGED:
      return action.valid ? null : (action.reason || null);
    case PROMO_CODE_CHANGED:
    case PROMO_CODE_NAME_CHANGED:
    case CANCEL_CHECKOUT:
      return null;
    default:
      return state;
  }
};

const ticketReservation = (state = {}, action) => {
  switch (action.type) {
    case TICKET_RESERVATION_CHANGED:
      return action.ticketReservation;
    case CANCEL_CHECKOUT:
      return {};
    default:
      return state;
  }
};

const stripePromise = (state = {}, action) => {
  switch (action.type) {
    case STRIPE_PROMISE_CHANGED:
      return action.stripePromise;
    default:
      return state;
  }
};

const stripePublishableKey = (state = "", action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const stripeConnectedAccountId = (state = null, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const stripeError = (state = {}, action) => {
  switch (action.type) {
    case CANCEL_CHECKOUT:
      return {};
    case STRIPE_ERROR_CHANGED:
      return action.error;
    default:
      return state;
  }
};

const rootUrl = (state = "", action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const checkoutTimePercentageRemaining = (state = 0, action) => {
  switch (action.type) {
    case CHECKOUT_TIME_PERCENTAGE_REMAINING_CHANGED:
      return action.percentage;
    case CANCEL_CHECKOUT:
      return 0;
    default:
      return state;
  }
};

const timeLimitReached = (state = false, action) => {
  switch (action.type) {
    case TIME_LIMIT_REACHED_CHANGED:
      return action.reached;
    default:
      return state;
  }
};

const isPlacingOrder = (state = false, action) => {
  switch (action.type) {
    case IS_PLACING_ORDER_CHANGED:
      return action.isPlacingOrder;
    case CANCEL_CHECKOUT:
      return false;
    default:
      return state;
  }
};

const addOns = (state = [], action) => {
  switch (action.type) {
    case ADD_ONS_CHANGED:
      return action.addOns;
    case CANCEL_CHECKOUT:
      return [...state].map((tt) =>
        Object.assign({}, tt, {
          seatsIOObjects: [],
          quantity: 0
        })
      );
    default:
      return state;
  }
};

const googleTrackingIds = (state = [], action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const gtag = (state = () => {}, action) => {
  switch (action.type) {
    case GTAG_CHANGED:
      return action.gtag;
    default:
      return state;
  }
};

const customFieldValues = (state = [], action) => {
  switch (action.type) {
    case CUSTOM_FIELD_VALUE_CHANGED:
      return replaceOrAddAnswer(state, action.customFieldValue);
    default:
      return state;
  }
};

const userContext = (state = {}, action) => {
  switch (action.type) {
    case USER_CONTEXT_CHANGED:
      return action.userContext;
    default:
      return state;
  }
};

const seatsIOPublicKey = (state = "", action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const seatsIOChart = (state = {}, action) => {
  switch (action.type) {
    case SEATS_IO_CHART_CHANGED:
      return action.seatsIOChart;
    default:
      return state;
  }
};

const seatsIOSelectedObjects = (state = [], action) => {
  switch (action.type) {
    case SEATS_IO_SELECTED_OBJECTS_CHANGED:
      return action.seatsIOSelectedObjects;
    case CANCEL_CHECKOUT:
      return [];
    default:
      return state;
  }
};

const customerioId = (state = "", action) => {
  switch (action.type) {
    case CUSTOMERIO_ID_CHANGED:
      return action.customerioId;
    default:
      return state;
  }
};

const parentUrl = (state = "", action) => {
  switch (action.type) {
    case PARENT_URL_CHANGED:
      return action.parentUrl;
    default:
      return state;
  }
};

const originAttribution = (state = {}, action) => {
  switch (action.type) {
    case ORIGIN_ATTRIBUTION_CHANGED:
      return action.originAttribution;
    default:
      return state;
  }
};

const metaClickId = (state = "", action) => {
  switch (action.type) {
    case META_CLICK_ID_CHANGED:
      return action.metaClickId;
    default:
      return state;
  }
};

const attributionVisitorUuid = (state = "", action) => {
  switch (action.type) {
    case ATTRIBUTION_VISITOR_CHANGED:
      return action.attributionVisitorUuid;
    default:
      return state;
  }
};

const isCreatingTicketReservation = (state = false, action) => {
  switch (action.type) {
    case IS_CREATING_TICKET_RESERVATION_CHANGED:
      return action.isCreatingTicketReservation;
    default:
      return state;
  }
};

const cartStartBusyMessage = (state = null, action) => {
  switch (action.type) {
    case CART_START_BUSY_MESSAGE_CHANGED:
      return action.cartStartBusyMessage;
    default:
      return state;
  }
};

const verticalInsureClientID = (state = "", action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const insuranceOfferState = (state = "", action) => {
  switch (action.type) {
    case INSURANCE_OFFER_STATE_CHANGED:
      return action.insuranceOfferState;
    default:
      return state;
  }
};

const ticketInsurance = (state = {}, action) => {
  switch (action.type) {
    case TICKET_INSURANCE_CHANGED:
      return action.ticketInsurance;
    default:
      return state;
  }
};

const hasInsuranceQuote = (state = false, action) => {
  switch (action.type) {
    case HAS_INSURANCE_QUOTE_CHANGED:
      return action.hasInsuranceQuote;
    default:
      return state;
  }
};

const announceListEnabled = (state = false, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const waitlistEnabled = (state = false, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const donationCustomChargeType = (state = {}, action) => {
  switch (action.type) {
    case DONATION_CUSTOM_CHARGE_TYPE_CHANGED:
      return action.donationCustomChargeType;
    case CANCEL_CHECKOUT:
      return {
        ...state,
        enteredPrice: undefined,
        price: undefined,
        coverProcessing: undefined
      };
    default:
      return state;
  }
};

const feeRules = (state = [], action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const startAtAddOns = (state = false, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const ticketsSoldElsewhere = (state = false) => state;

const startAtDonation = (state = false, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const showHeader = (state = true, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const showCheckoutDate = (state = false, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const checkoutCategories = (state = [], action) => {
  switch (action.type) {
    case CHECKOUT_CATEGORIES_REPLACED:
      return action.checkoutCategories || state;
    default:
      return state;
  }
};

// widgetConfig is initialized from rails props and updated live by the
// custom widget builder via dispatched WIDGET_CONFIG_REPLACED actions
// (see WebOrderFormApp). widgetType doesn't change after init in any path
// today, so it stays as a pass-through.
const widgetConfig = (state = {}, action) => {
  switch (action.type) {
    case WIDGET_CONFIG_REPLACED:
      return action.widgetConfig || state;
    default:
      return state;
  }
};

const restrictedTicketTypeId = (state = null, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const restrictedTicketGroupId = (state = null, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const entryTimeLabel = (state = null, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const seriesReturnUrl = (state = null, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const widgetType = (state = 'club', action) => state;

// Set to `true` only when the form is mounted inside the custom widget
// builder preview. Lets the builder preview bypass public-facing gates
// (sales-not-started, sold-out, canceled, etc.) so the admin sees the
// configured ticket rows even before publication.
const adminPreview = (state = false, action) => state;

// Set to `true` when the embedder passes ?default_theme=true on the iframe
// URL. Bypasses the customer-configured Custom widget theme so the widget
// renders with Opendate's default colors/fonts (Custom structure still
// renders). Used by Opendate's own /e/<slug> page wrapping the iframe.
const useDefaultTheme = (state = false, action) => state;

const widgetTemplateId = (state = null, action) => state;

const ticketGroups = (state = {}, action) => {
  switch (action.type) {
    case TICKET_GROUPS_CHANGED:
      return action.ticketGroups;
    default:
      return state;
  }
};

const verb = (state = "", action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const membershipProducts = (state = [], action) => {
  switch (action.type) {
    case MEMBERSHIP_PRODUCTS_CHANGED:
      return action.membershipProducts;
    default:
      return state;
  }
};

const selectedMembershipProduct = (state = null, action) => {
  switch (action.type) {
    case SELECTED_MEMBERSHIP_PRODUCT_CHANGED:
      return action.selectedMembershipProduct;
    case CANCEL_CHECKOUT:
      return null;
    default:
      return state;
  }
};

const resaleListings = (state = [], action) => {
  switch (action.type) {
    case RESALE_LISTINGS_FETCHED:
      return action.resaleListings;
    default:
      return state;
  }
};

const resaleOrderItems = (state = [], action) => {
  switch (action.type) {
    case RESALE_QUANTITY_CHANGED: {
      var quantity = parseInt(action.quantity, 10) || 0;
      var existingIndex = state.findIndex((s) => s.listingId === action.listingId);

      if(quantity <= 0){
        if(existingIndex < 0) return state;
        return [...state.slice(0, existingIndex), ...state.slice(existingIndex + 1)];
      }

      var nextEntry = {
        listingId: action.listingId,
        quantity: quantity,
        ticketTypeName: action.ticketTypeName,
        listPriceCents: action.listPriceCents,
        buyerTotalPerTicketCents: action.buyerTotalPerTicketCents
      };

      if(existingIndex >= 0){
        var nextState = [...state];
        nextState[existingIndex] = nextEntry;
        return nextState;
      }

      return [...state, nextEntry];
    }
    case RESALE_LISTINGS_FETCHED: {
      var listingIds = (action.resaleListings || []).map((l) => l.id);
      return state.filter((s) => listingIds.indexOf(s.listingId) >= 0);
    }
    case CANCEL_CHECKOUT:
      return [];
    default:
      return state;
  }
};

const webOrderFormReducer = combineReducers({
  team,
  csrfToken,
  priceQuoteToken,
  priceQuoteVisitorId,
  checkoutToken,
  revealedHold,
  confirm,
  ticketTypes,
  promoCode,
  promoCodeName,
  promoCodeNameValid,
  promoCodeInvalidReason,
  ticketReservation,
  stripePromise,
  stripePublishableKey,
  stripeConnectedAccountId,
  stripeError,
  rootUrl,
  checkoutTimePercentageRemaining,
  timeLimitReached,
  isPlacingOrder,
  addOns,
  googleTrackingIds,
  gtag,
  customFieldValues,
  userContext,
  seatsIOPublicKey,
  seatsIOChart,
  seatsIOSelectedObjects,
  customerioId,
  parentUrl,
  originAttribution,
  metaClickId,
  attributionVisitorUuid,
  isCreatingTicketReservation,
  cartStartBusyMessage,
  verticalInsureClientID,
  insuranceOfferState,
  ticketInsurance,
  hasInsuranceQuote,
  announceListEnabled,
  waitlistEnabled,
  donationCustomChargeType,
  feeRules,
  startAtAddOns,
  ticketsSoldElsewhere,
  startAtDonation,
  showHeader,
  showCheckoutDate,
  checkoutCategories,
  restrictedTicketTypeId,
  restrictedTicketGroupId,
  entryTimeLabel,
  seriesReturnUrl,
  ticketGroups,
  verb,
  membershipProducts,
  selectedMembershipProduct,
  widgetConfig,
  widgetType,
  adminPreview,
  useDefaultTheme,
  widgetTemplateId,
  resaleListings,
  resaleOrderItems,
});

export default webOrderFormReducer;
